import React from 'react'
import { MultiSelect } from 'components'
import { useGetStore } from 'hooks'

type StoreProps = {
  storeState: {
    region: string[]
    storeFormat: string[]
    store: string[]
    storeName: string[]
  }
  onChange(store: string[], storeName: string[], isDefaultAll?: boolean): void
}

export const SelectStore = (props: StoreProps) => {
  const { storeState, onChange } = props
  const { region, storeFormat, store, storeName } = storeState

  const { storeStatus, storeData, storeError } = useGetStore(region, storeFormat)

  const isEnabled = region.length && storeFormat.length

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (isEnabled) {
      if (storeStatus === 'error') {
        return storeError?.errorMessage ?? 'Network Error!'
      }
      if (!store.length) {
        if (fieldError) return true
        else if (setValidation) setFieldError('triggered')
      }
      return ''
    }
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const handleStoreChange = (selectedStoreId: string[], selectedStoreName: string[], isDefaultAll?: boolean) => {
    onChange(selectedStoreId, selectedStoreName, isDefaultAll)
  }

  return (
    <div className="w-full sm:w-64">
      <MultiSelect
        placeholder="Select store"
        label="Store *"
        id="store"
        isLoading={storeStatus === 'loading'}
        disabled={!isEnabled}
        value={{ value: store, text: storeName }}
        onChange={handleStoreChange}
        options={(storeData || []).map((item) => ({
          value: item.location_id,
          text: `${item.location_id} - ${item.location_long_name}`,
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
        enableSearch={true}
      />
    </div>
  )
}
